import { render, staticRenderFns } from "./Mp3ExtractorUrlForm.vue?vue&type=template&id=aef1b27e&scoped=true&"
import script from "./Mp3ExtractorUrlForm.vue?vue&type=script&lang=ts&"
export * from "./Mp3ExtractorUrlForm.vue?vue&type=script&lang=ts&"
import style0 from "./Mp3ExtractorUrlForm.vue?vue&type=style&index=0&id=aef1b27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef1b27e",
  null
  
)

export default component.exports